import { put, select } from "redux-saga/effects";
import axios from "../../config/axiosConfig";
import {
	GET_ALL_CATEGORY_ERROR,
	GET_ALL_CATEGORY_SUCCESS,
	GET_ALL_CATEGORY_UNCHANGED,
	GET_CATEGORY_DETAIL_ERROR,
	GET_CATEGORY_DETAIL_SUCCESS,
	GET_CATEGORY_DETAIL_UNCHANGED,
	GET_CUSTOM_CATEGORY_DETAIL_SUCCESS,
	GET_CUSTOM_CATEGORY_DETAIL_FAILED,
	GET_CUSTOM_CATEGORY_DETAIL_UNCHANGED,
} from "../actions/categoryActions";
import { TOAST_SHOW } from "../actions/toastActions";
import { GET_USER_FOUND } from "../actions/authActions";
import { ERROR_CODES } from '../../constants/errorCodes';
import { runCachedContentRequest } from "./contentCacheSaga";
import { contentScopeChangedAction } from "../actions/contentCacheActions";

export function* fetchCategoryDetails(action) {
	const categoryId = action?.payload?.cat_id;
	const result = yield* runCachedContentRequest({
		resource: "category",
		params: { categoryId: String(categoryId ?? ""), variant: "standard" },
		requestKey: action?.requestKey || `category:${String(categoryId ?? "")}`,
		fetchRequest: () => axios.post(`api/category?t=${Date.now()}`, action.payload),
		cacheSuccessType: GET_CATEGORY_DETAIL_SUCCESS,
		networkSuccessType: GET_CATEGORY_DETAIL_SUCCESS,
		unchangedType: GET_CATEGORY_DETAIL_UNCHANGED,
		errorType: GET_CATEGORY_DETAIL_ERROR,
	});
	if (result?.error && !result.hasCachedData) {
		yield put({ type: TOAST_SHOW, payload: { message: `${ERROR_CODES.E2001}: Something went wrong please try again`,severity: "Danger",show: true } });
	}
}

export function* fetchAllCategorySaga(action) {
	const result = yield* runCachedContentRequest({
		resource: "categories",
		requestKey: action?.requestKey || "categories",
		fetchRequest: () => axios.get(`api/categories?t=${Date.now()}`),
		cacheSuccessType: GET_ALL_CATEGORY_SUCCESS,
		networkSuccessType: GET_ALL_CATEGORY_SUCCESS,
		unchangedType: GET_ALL_CATEGORY_UNCHANGED,
		errorType: GET_ALL_CATEGORY_ERROR,
	});
	if (result?.error && !result.hasCachedData) {
		yield put({ type: TOAST_SHOW, payload: { message: `${ERROR_CODES.E2002}: Something went wrong please try again`, severity: "Danger",show: true } });
	}
}


export function* getCustomCategoryDetailSaga(action) {
	const categoryId = action?.payload?.cat_id;
	const result = yield* runCachedContentRequest({
		resource: "category",
		params: { categoryId: String(categoryId ?? ""), variant: "custom" },
		requestKey: action?.requestKey || `custom-category:${String(categoryId ?? "")}`,
		fetchRequest: () => axios.post(`api/category?t=${Date.now()}`, action.payload),
		cacheSuccessType: GET_CUSTOM_CATEGORY_DETAIL_SUCCESS,
		networkSuccessType: GET_CUSTOM_CATEGORY_DETAIL_SUCCESS,
		unchangedType: GET_CUSTOM_CATEGORY_DETAIL_UNCHANGED,
		errorType: GET_CUSTOM_CATEGORY_DETAIL_FAILED,
	});

	if (result?.response?.data?.user) {
		const response = result.response;
		const activeUserScope = yield select((state) => String(state?.Auth?.user?.id || "guest"));
		if (activeUserScope !== String(response.data.user.id)) {
			yield put(contentScopeChangedAction(response.data.user.id));
			yield put({
				type: GET_CUSTOM_CATEGORY_DETAIL_SUCCESS,
				payload: result.payload,
				requestKey: action?.requestKey || `custom-category:${String(categoryId ?? "")}`,
				source: "network",
				userScope: String(response.data.user.id),
			});
		}
		const userObj = {
			user: response?.data?.user,
			token: localStorage.getItem("token"),
			loginDetails: response?.data?.user,
			featured: {},
			balance: response?.data?.user?.balance,
			web3Login: {},
			web3LoginLoading: false,
			isWeb3Login: false,
			sections: [],
		};
		yield put({
			type: GET_USER_FOUND,
			payload: userObj,
			token: localStorage.getItem("token"),
		});
	}
	if (result?.error && !result.hasCachedData) {
		yield put({ type: TOAST_SHOW, payload: { message: `${ERROR_CODES.E2003}: Something went wrong please try again`,severity: "Danger",show: true } });
	}
}
